var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPieChart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 90,
    height: 89,
    viewBox: "0 0 90 89",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M45.8102 0.228516V43.121L83.8041 22.7687C79.9991 16.0139 74.4871 10.3768 67.8194 6.42111C61.1518 2.46546 53.5623 0.330063 45.8102 0.228516Z",
    fill: "#F5A2A7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M84.5924 24.2266L46.3579 44.695L76.9887 75.3286C85.0252 67.078 89.5154 56.0108 89.4993 44.4931C89.5084 37.4423 87.8257 30.4923 84.5924 24.2266Z",
    fill: "#8A9DAD"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M44.1506 0.236816C32.5974 0.516185 21.6111 5.30116 13.5376 13.57C5.46413 21.8389 0.943153 32.9363 0.940033 44.493C0.940033 50.3079 2.08544 56.0659 4.3108 61.4382C6.53617 66.8104 9.79791 71.6918 13.9098 75.8034C18.0217 79.9151 22.9033 83.1765 28.2757 85.4016C33.6481 87.6266 39.4062 88.7716 45.2211 88.7712C56.6173 88.7942 67.5802 84.406 75.8131 76.5261L44.1506 44.8636V0.236816Z",
    fill: "#E9353F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPieChart);
export default __webpack_public_path__ + "static/media/pie-chart.256d6dcb4fde100e4828ca980dceeb82.svg";
export { ForwardRef as ReactComponent };